module.exports = __webpack_public_path__ + "static/img/dzp6.8202843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp6.png
// module id = V18k
// module chunks = 1